module.exports = __webpack_public_path__ + "img/wangfangyu.20111709.jpg";